(function () {
  'use strict';

  const UI = {
    it: { loading: 'Caricamento…', unavailable: 'Contenuto non disponibile.', error: 'Errore nel caricamento del contenuto.' },
    en: { loading: 'Loading…', unavailable: 'Content not available.', error: 'Error loading content.' },
    fr: { loading: 'Chargement…', unavailable: 'Contenu non disponibile.', error: 'Erreur lors du chargement du contenu.' },
    de: { loading: 'Wird geladen…', unavailable: 'Inhalt nicht verfügbar.', error: 'Fehler beim Laden des Inhalts.' },
    es: { loading: 'Cargando…', unavailable: 'Contenido no disponible.', error: 'Error al cargar el contenido.' }
  };

  const CSS = `
.pd-widget, .pd-wrapper{display:block;box-sizing:border-box;border-top:1px solid #dddddd;border-bottom:1px solid #dddddd;background:transparent;max-width:900px;margin:0;padding:0}
.pd-widget:focus,.pd-widget:focus-within,.pd-wrapper:focus,.pd-wrapper:focus-within,.pd-toggle:focus,.pd-toggle:focus-visible{outline:none!important;box-shadow:none!important}
.pd-toggle{width:100%;display:flex;align-items:center;justify-content:space-between;padding:6px 0px;background:#fff;cursor:pointer;color:#2c2c2c;text-align:left;border:0;font-size:14px}
.pd-toggle::-moz-focus-inner{border:0}
.pd-panel{overflow:hidden;transition:max-height .28s ease,opacity .2s ease;background:#fff;max-height:0;opacity:0;border-top:none}
.pd-panel[aria-hidden="false"]{max-height:1200px;opacity:1}
.pd-content{padding:10px 10px;color:#2c2c2c;}
.pd-chev{margin-left:12px;font-weight:400;font-size:22px;transition:transform .12s ease}
@media (max-width:480px){.pd-toggle{padding:10px 12px}.pd-content{padding:12px}}
@media (prefers-reduced-motion: reduce){ .pd-panel{transition:none} .pd-chev{transition:none} }
`.trim();

  function injectStyles() {
    if (document.getElementById('pd-widget-styles')) return;
    const s = document.createElement('style');
    s.id = 'pd-widget-styles';
    s.type = 'text/css';
    s.appendChild(document.createTextNode(CSS));
    document.head.appendChild(s);
  }

  const globalCache = new Map();

  function localeFromPathname() {
    const m = window.location.pathname.match(/^\/([a-z]{2,3})(?:[\/-]|$)/i);
    return m ? m[1].toLowerCase() : '';
  }

  function detectLocale() {
    const fromPath = localeFromPathname();
    if (fromPath) return fromPath.slice(0,2).toLowerCase();
    const htmlLang = document.documentElement.lang;
    if (htmlLang) return htmlLang.slice(0,2).toLowerCase();
    const nav = navigator.language || navigator.userLanguage || '';
    if (nav) return nav.slice(0,2).toLowerCase();
    return '';
  }

  function normalizeLocaleCode(code) {
    if (!code) return '';
    return String(code).slice(0,2).toLowerCase();
  }

  function buildCandidateUrls(locale, handle) {
    const loc = normalizeLocaleCode(locale);
    const urls = [];
    if (loc && loc !== 'it') {
      urls.push(`/${loc}/pages/${encodeURIComponent(handle)}.json`);
    }
    urls.push(`/pages/${encodeURIComponent(handle)}.json`);
    return urls;
  }

  async function fetchFirstJson(urls) {
    for (let i = 0; i < urls.length; i++) {
      const url = urls[i];
      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) {
          // try next
          continue;
        }
        const json = await res.json();
        return { json, url };
      } catch (e) {
        // network error -> try next
        continue;
      }
    }
    throw new Error('No valid JSON found');
  }

  function createWidgetMarkup(T) {
    const wrapper = document.createElement('div');
    wrapper.className = 'pd-wrapper';
    wrapper.innerHTML = `
<button type="button" class="pd-toggle" aria-expanded="false" aria-controls="">
  <span class="pd-title">${T.loading}</span>
  <span class="pd-chev" aria-hidden="true">+</span>
</button>
<div class="pd-panel" hidden aria-hidden="true" data-loaded="false">
  <div class="pd-content" aria-live="polite">${T.loading}</div>
</div>`;
    return wrapper;
  }

  function enhanceWidget(host) {
    const handle = String(host.getAttribute('data-handle') || '').trim();
    if (!handle) return;

    const locale = detectLocale();
    const T = UI[locale] || UI['it'];

    host.innerHTML = '';
    const widget = createWidgetMarkup(T);
    while (widget.firstChild) host.appendChild(widget.firstChild);

    const toggle = host.querySelector('.pd-toggle');
    const panel = host.querySelector('.pd-panel');
    const content = host.querySelector('.pd-content');
    const symbol = host.querySelector('.pd-chev');
    const titleEl = host.querySelector('.pd-title');

    if (!panel.id || !panel.id.startsWith('pd-panel-')) {
      panel.id = 'pd-panel-' + Math.random().toString(36).slice(2,9);
      toggle.setAttribute('aria-controls', panel.id);
    }

    titleEl.textContent = T.loading;
    symbol.textContent = '+';
    if (!panel.dataset.loaded) panel.dataset.loaded = 'false';

    const cached = globalCache.get(handle) || { title: null, bodyHtml: null };
    if (cached.title) titleEl.textContent = cached.title;

    const doPrefetch = () => {
      const urls = buildCandidateUrls(locale, handle);
      fetchFirstJson(urls)
        .then(result => {
          if (result && result.json && result.json.page) {
            const p = result.json.page;
            const title = p.title || null;
            const bodyHtml = p.body_html || null;
            globalCache.set(handle, { title, bodyHtml });
            if (title) titleEl.textContent = title;
          }
        })
        .catch(() => { /* silent */ });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(doPrefetch, { timeout: 1000 });
    } else {
      setTimeout(doPrefetch, 500);
    }

    async function openPanel() {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      if (symbol) symbol.textContent = '-';
      if (panel.dataset.loaded === 'true') return;

      const cachedNow = globalCache.get(handle);
      if (cachedNow && cachedNow.bodyHtml !== null) {
        content.innerHTML = cachedNow.bodyHtml || `<p>${T.unavailable}</p>`;
        panel.dataset.loaded = 'true';
        return;
      }

      content.textContent = T.loading;
      const urls = buildCandidateUrls(locale, handle);
      try {
        const result = await fetchFirstJson(urls);
        if (result && result.json && result.json.page) {
          const p = result.json.page;
          if (p.title) titleEl.textContent = p.title;
          content.innerHTML = p.body_html || `<p>${T.unavailable}</p>`;
          globalCache.set(handle, { title: p.title || null, bodyHtml: p.body_html || null });
          panel.dataset.loaded = 'true';
        } else {
          content.innerHTML = `<p>${T.unavailable}</p>`;
          panel.dataset.loaded = 'true';
        }
      } catch (err) {
        content.innerHTML = `<p>${T.error}</p>`;
      }
    }

    function closePanel() {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      if (symbol) symbol.textContent = '+';
    }

    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      expanded ? closePanel() : openPanel();
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        expanded ? closePanel() : openPanel();
      }
    });

    if (!window.__pd_escape_installed) {
      window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.pd-widget .pd-toggle[aria-expanded="true"]').forEach(function (t) {
            t.click();
          });
        }
      });
      window.__pd_escape_installed = true;
    }
  }

  function initAll() {
    injectStyles();
    const hosts = document.querySelectorAll('.pd-widget');
    if (!hosts || hosts.length === 0) return;
    hosts.forEach(h => {
      try { enhanceWidget(h); } catch (err) { }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
